import type { BeDayOfWeek, WeekDay } from 'types/entities/shared'

const MAP: Readonly<Record<BeDayOfWeek, WeekDay>> = {
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
}

/**
 * Converts BE's java.time.DayOfWeek enum-name serialization (uppercase)
 * to FE's display-form WeekDay union (capitalized).
 */
export const beDayOfWeekToWeekDay = (be: BeDayOfWeek): WeekDay => MAP[be]
